// GENERIC NON-AXOS RELATED ROUTINES
//
//
//
import { UAParser } from 'ua-parser-js';
import { removeOutliers } from '../util/performance';
var parser = require('ua-parser-js');       // UA parse library


// MISC UTILITY FUNCTIONS
//
// NOTE: UserAgent is being degraded soon: https://web.dev/migrate-to-ua-ch/
//
export class UtilClass {
    _parser = null;

    // must call this first
    //
    getUserAgent() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        this._parser = parser(userAgent);

        console.log("util.20:  UA Parser = ",this._parser);
        return userAgent;
    }


    // run a loop to assess CPU speed relative to HP Envy laptop (2018)
    getCPUSpeed() {
        const sample_loop = 60;
        const big_loop = 6;    // can't be too big
        const small_loop = 300000;    // can't be too big
        const factor = 580;
        var f1, f2, s1, s2, df, ds, sum = 0, delta, deltas = [];

        for(var j = 0; j < sample_loop; j++) {
            f1 = performance.now();
            s1 = Date.now();
            for (var i = 0; i < big_loop; i++) {
                for (var k = 0; k < small_loop; k++) {
                    var sum = i * j
                }
            };
            f2 = performance.now();
            s2 = Date.now();
            df = f2 - f1;
            ds = s2 - s1;
            //console.log(j+":  fast.delta="+ df + "  fast.delta="+ ds);
            delta = (df > 0) ? df : ds;
            deltas.push(delta);
            sum = sum + delta;
        }
        //console.log("deltas="+ newd+"  d="+d+ " sum="+ sum);

        var thresh = ((sum / sample_loop) < 2) ? 2 : 0.5;
        var [ avg, rcnt ] = removeOutliers(deltas, "CPU_SPEED", thresh);     // run histogram and remove outliers

        var spd = Math.round(factor / avg);
        console.log("Estimated speed factor: " + spd, "  rcnt=", rcnt);     // relative to Envy2 Laptop (@100)
        return spd;
    }



    // src: https://developer.apple.com/library/archive/documentation/DeviceInformation/Reference/iOSDeviceCompatibility/HardwareGPUInformation/HardwareGPUInformation.html
    getIphoneModel(renderer) {
            switch (renderer) {
                case "S5L8900":
                    return "1";
                    //return "iPhone 1, 3G";
                case "ALP0298C05":
                    return "3";
                    //return "iPhone 3GS";
                case "PowerVR SGX 535":
                    return "4";
                    //return "iPhone 4";
                case "PowerVR SGX 543":
                    return "5";
                    //return "iPhone 5 or 5c";
                case "Apple A7 GPU":
                    return "5";
                    //return "iPhone 5s";
                case "Apple A8 GPU":
                    return "6";
                    //return "iPhone 6 Plus";
                case "Apple A9 GPU":
                    return "6";
                    //return "iPhone 6s Plus";
                case "Apple A10 GPU":
                    return "7";
                    //return "iPhone 7 Plus";
                case "Apple A11 GPU":
                    return "8";
                    //return "iPhone 8 Plus";
                case "Apple A12 GPU":
                    return "XS";
                case "Apple A12X GPU":
                    return "XS";
                case "Apple A13 GPU":
                    return "11";
                case "Apple A14 GPU":
                    return "12";
                default:
                    return "?";
                    //return "iPhone 6 Plus, 6s Plus, 7 Plus or 8 Plus";
            }
    }

    getIOSVer(userAgent) {
        var os_ver;

        var res = userAgent.match(/; CPU.*OS (\d\d_\d)/);
        if(res) {
            var strVer = res[res.length-1];
            strVer = strVer.replace("_", ".");
            os_ver = strVer * 1;
        } else {
            return "unk"
        }
        //console.log("IOS=",os_ver);
        return os_ver;
    }


    // returns [ model: 6, 7, 8, XS,  mode: normal, zoom]
    // table: https://www.icwebdesign.co.uk/common-viewport-sizes
    getIphoneDevice(userAgent, renderer) {
        // Create a canvas element which can be used to retrieve information about the GPU.
        var model = this.getIphoneModel(renderer);
        var os_ver = "unk";

        // Mozilla/5.0 (iPhone; CPU iPhone OS 14_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) CriOS/87.0.4280.77 Mobile/15E148 Safari/604.1
        //iPhone OS 14_4 like
        var os_ver = this.getIOSVer(userAgent);

        var width =window.screen.width * window.devicePixelRatio;       // actual pixels
        var height =window.screen.height * window.devicePixelRatio;

        //if ((window.screen.height / window.screen.width == 1792 / 828) && (window.devicePixelRatio == 3)) {
        if ((window.screen.height / window.screen.width == 2340 / 1080)) { // && (window.devicePixelRatio == 2)) {
            return [os_ver, "12m", "normal"];
        } else if ((window.screen.height / window.screen.width == 2532 / 1170)) { // && (window.devicePixelRatio == 2)) {
            return [os_ver, "12", "normal"];
        //if ((window.screen.height / window.screen.width == 1792 / 828) && (window.devicePixelRatio == 3)) {
        } else if ((window.screen.height / window.screen.width == 896 / 414)) {  // && (window.devicePixelRatio == 2)) {
            return [os_ver, "11", "normal"];
            
        } else if ((window.screen.height / window.screen.width == 812 / 375) && (window.devicePixelRatio == 3)) {
            return [os_ver, "x", "normal"];

        // iPhone 6+/6s+/7+ and 8+
        } else if ((window.screen.height / window.screen.width == 736 / 414) && (window.devicePixelRatio == 3)) {
            // 8 = 1334 × 750

        // iPhone 6+/6s+/7+ and 8+ in zoom mode
        } else if ((window.screen.height / window.screen.width == 667 / 375) && (window.devicePixelRatio == 3)) {
            if (os_ver >= 13) {
                return [os_ver, "8", "zoom"];     // need a way to tell: 6s, SE, 7, 8!
            } else {
                return [os_ver, "6", "zoom"];     // not 6s or 6s+
            }

        // iPhone 6/6s/7 and 8
        } else if ((window.screen.height / window.screen.width == 667 / 375) && (window.devicePixelRatio == 2)) {
            if (os_ver >= 13) {
                return [os_ver, "8", "normal"];     // need a way to tell: 6s, SE, 7, 8!
            } else {
                return [os_ver, "6", "normal"];     // not 6s or 6s+
            }

        // iPhone 5/5C/5s/SE or 6/6s/7 and 8 in zoom mode
        } else if ((window.screen.height / window.screen.width == 1.775) && (window.devicePixelRatio == 2)) {
            return [os_ver, "5", "zoom"];

        // iPhone 4/4s
        } else if ((window.screen.height / window.screen.width == 1.5) && (window.devicePixelRatio == 2)) {
            return [os_ver, "4", "normal"];

        // iPhone 1/3G/3GS
        } else if ((window.screen.height / window.screen.width == 1.5) && (window.devicePixelRatio == 1)) {
            return [os_ver, "1", "normal"];
        } else {
            return [os_ver, "unknown", "normal"];
        }
    }

    getAndriodDevice(userAgent, renderer) {
        // Mozilla/5.0 (Linux; Android 6.0; Nexus 5 Build/MRA58N) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/65.0.3325.181 Mobile Safari/537.36
        // Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G960U)
        var version = "unk", model = "unk";

        var bits = userAgent.split(")")[0].split(";");
        if(bits.length >= 3) {
            version =bits[1].trim().split(" ")[1];
            model =bits[2].trim().replace(/ Build.*$/, "")
        }

        return [ version, model ];
    }


    // using ua-parser lib
    //
    // returns [browser, browser.ver, engine, engine.ver  ]
    getBrowserType() {
        var browser = this._parser.browser;
        var engine = this._parser.engine;

        /*
        var out = {}
        out.browser = browser.name;
        out.browser_ver = browser.version; 
        out.engine = engine.name; 
        out.engine_ver = engine.version;
        return out;
        */

        return [ browser.name, browser.version, engine.name, engine.version]
    }



    // returns [SIZE: tv, pc, tablet, phone  TYPE: iphone, android, mac, win, MODEL: X, 9, 8]
    getDeviceType() {
        var renderer = null;
        // agent.db: https://developers.whatismybrowser.com/useragents/explore/
        // agent.lib: https://github.com/ahand/mobileesp/blob/master/MobileESP_UA-Test-Strings/MobileESP%20UA%20Test%20Strings%20-%20UA%20Strings.csv
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        var canvas = document.createElement("canvas");
        if (canvas) {
            var context = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
            if (context) {
                var info = context.getExtension("WEBGL_debug_renderer_info");
                if (info) {
                    renderer = context.getParameter(info.UNMASKED_RENDERER_WEBGL);
                }
            }
        }
        var width = Math.floor(window.screen.width * window.devicePixelRatio);       // actual pixels
        var height = Math.floor(window.screen.height * window.devicePixelRatio);

        var cpu = window.navigator.hardwareConcurrency;
        var spd = this.getCPUSpeed();

        console.log("247:  DEV_SPEC: cpu=",cpu, "spd=", spd, " s.wd=",width, " s.ht=",height, " s.aspect=",Math.floor(window.devicePixelRatio), " webgl=",renderer);
        if(!userAgent) {
            return ["error", "error", "error", "error", spd]
        }

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows nt/i.test(userAgent)) {
            return ["pc", "win", "10", "win", spd]

        } else if (/windows phone/i.test(userAgent)) {
            return ["phone", "android", "unk", "window", spd];

        } else if (/android/i.test(userAgent)) {
            const [ os_ver, dev_model ] = this.getAndriodDevice(userAgent, renderer);
            return ["phone", "android", os_ver, dev_model, spd];

        } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            // iphone detection from: http://stackoverflow.com/a/9039885/177710
            //var dev_type="unknown"
            var dev_model="unknown"
            if (/iPhone/.test(userAgent)) {
                const [os_ver, dev_model] = this.getIphoneDevice(userAgent, renderer);
                //return ["phone", "iphone", os_ver, dev_model, spd];
                return ["phone", "ios", os_ver, dev_model, spd];

            } else if (/iPad/.test(userAgent)) {
                return ["tablet", "ios", this.getIOSVer(userAgent), "ipad", spd];

            } else if (/iPod/.test(userAgent)) {
                return ["phone", "ios", "unk", "ipod", spd];
            }
        } else if (/Mac/.test(userAgent)) {
            return ["pc", "mac", "unk", "mac", spd]

        } else if (/silk/i.test(userAgent)) {
            //console.log("dev.263:        silk=", /silk/i.test(userAgent));
            return ["phone", "amazon", "unk", "amazon", spd];
        } else {
            //return ["pc", "win", "win"]
            return ["phone", "android", "unk", "android", spd]
        }

        return ["unk", "unk", "unk", "unk", spd]
    }

    isiOS() {
        return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    }

    isAndroid() {
        return /Android/i.test(navigator.userAgent);
    }

    isMobile() {
        return this.isAndroid() || this.isiOS();
    }
}
